<template>
  <div
    :id="'filter-item-and-' + andIndex"
    :class="{ 'm-t-0': andIndex == 0 }"
    class="bs-callout bs-callout-primary bs-callout-xs m-b-10 p-10"
  >
    <div v-if="!useInReportingFilters">
      <OrCriteria
        v-for="(orCriteria, index) in criteria"
        :id="'filter-item-or-' + andIndex + '-' + index"
        :key="index"
        :or-criteria="orCriteria"
        :is-read-only="isReadOnly"
        :is-full-width="isFullWidth"
        :is-summary-view="isSummaryView"
        :and-index="andIndex"
        :or-index="index"
        :available-tags="availableTags"
        :form-name-for-user-settings="formNameForUserSettings"
        :has-bulk-comparison-type="hasBulkComparisonType"
        :bulk-comparison-index="bulkComparisonTypeIndex"
        @change="(orCriteria) => handleOrChange(index, orCriteria)"
        @removeRule="(orIndex) => removeOrCriteria(orIndex)"
      />
    </div>

    <div v-if="useInReportingFilters">
      <ReportingOrCriteria
        v-for="(orCriteria, index) in criteria"
        :id="'filter-item-or-' + andIndex + '-' + index"
        :key="index"
        :or-criteria="orCriteria"
        :is-read-only="isReadOnly"
        :is-full-width="isFullWidth"
        :is-summary-view="isSummaryView"
        :and-index="andIndex"
        :or-index="index"
        :available-tags="availableTags"
        :form-name-for-user-settings="formNameForUserSettings"
        :values-for-filter="valuesForReportingFilter"
        :event-category="eventCategory"
        @change="(orCriteria) => handleOrChange(index, orCriteria)"
        @removeRule="(orIndex) => removeOrCriteria(orIndex)"
      />
    </div>

    <button
      v-t="'ROUTER_FILTER_ADD_OR'"
      class="btn btn-primary btn-xs m-t-5" 
      type="button"
      @click="$emit('addORRule', andIndex)"
    />      
      
    <button
      v-t="'ROUTER_FILTER_ADD_AND'"
      class="btn btn-primary btn-xs m-l-10 m-t-5"
      type="button"
      @click="$emit('addANDRule', andIndex)" 
    />
  </div>
</template>

<script>
import { isEqual } from 'lodash';

import messages from './locales';
import OrCriteria from './OrCriteria';
import ReportingOrCriteria from './ReportingOrCriteria/ReportingOrCriteria';

export default {
  name: 'AndCriteria',
  components: { OrCriteria, ReportingOrCriteria },
  props: {
    andCriteria: {
      type: Array,
      default() {
        return [];
      }
    },
    isReadOnly: {
      type: Boolean,
      default: false
    },
    isFullWidth: {
      type: Boolean,
      default: false
    },
    isSummaryView: {
      type: Boolean,
      default: false
    },
    isMobileView: {
      type: Boolean,
      default: false
    },
    andIndex: {
      type: Number,
      default: -1
    },
    uSStates: {
      type: Array,
      default() { return []; }
    },
    formNameForUserSettings: {
      type: String,
      default: ''
    },
    availableTags: {
      type: Array,
      default() {
        return [];
      }
    },
    useInReportingFilters: {
      type: Boolean,
      default: false
    },
    valuesForReportingFilter: {
      type: Object,
      default() {
        return {};
      }
    },
    eventCategory: {
      type: String,
      default: 'reporting-filter'
    }
  },

  data() {
    return {
      criteria: this.andCriteria
    };
  },

  computed: {
    hasBulkComparisonType() {
      return this.andCriteria.some(t => t.comparisonTypeTemp?.forBulkTags);
    },

    bulkComparisonTypeIndex() {
      return this.andCriteria.findIndex(t => t.comparisonTypeTemp?.forBulkTags);
    }
  },

  watch: {
    andCriteria: {
      immediate: true,
      handler(newValue, oldValue) {
        if(!isEqual(newValue, oldValue)) {
          this.criteria = newValue;
        }
      }
    }
  },
  methods: {
    handleOrChange(orIndex, orCriteria) {
      if (this.criteria && orCriteria) {
        if (this.criteria.length >= orIndex + 1) {
          this.criteria[orIndex] = orCriteria;
        } else {
          this.criteria.push(orCriteria);
        }

        this.$emit('change', this.criteria, this.andIndex);
      }
    },
    removeOrCriteria(orIndex) {
      if (this.criteria && this.criteria.length >= orIndex + 1) {
        this.criteria.splice(orIndex, 1);

        this.$emit('change', this.criteria, this.andIndex);
      }
    }
  },
  i18n: {
    messages,
    locale: 'en'
  }
};
</script>

<style>

</style>